export function setupAnalyticsTracking(router) {
  router.afterEach((to) => {
    // Microsoft Clarity
    if (window.clarity) {
      window.clarity('set', 'current_page', to.fullPath)
    }

    // Google Analytics 4
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_location: window.location.href,
        page_title: document.title
      })
    }
  })
}
